import { EnvType } from './env-type';
import { ServiceApiBaseUrls } from './service-api-base-urls';
import { OnboardingSiteConfig } from './onboarding-site-config';
import { AccountManagerSiteConfig } from './account-manager-site-config';
import { TrackJSInstallOptions } from 'trackjs';
import { IInitConfig } from 'flagsmith-es/types';

export class Environment {
  name!: EnvType;
  soleraSiteUrl!:
    | 'https://navigation2-preprod.omnitracs.com'
    | 'https://navigation2-qa.omnitracs.com'
    | 'https://navigation2.omnitracs.com';
  onboardingSiteUrl!:
    | 'https://onboarding-preprod.trimblemaps.com'
    | 'https://onboarding-qa.trimblemaps.com'
    | 'https://onboarding.trimblemaps.com';
  routeReporterUrl!:
    | 'https://routereporter-preprod.trimblemaps.com'
    | 'https://routereporter-qa.trimblemaps.com'
    | 'https://routereporter.trimblemaps.com';

  contentToolsUrl!:
    | 'https://contenttools-preprod.alk.com'
    | 'https://contenttools-qa.alk.com'
    | 'https://contenttools.alk.com';

  trackjsConfig: TrackJSInstallOptions = {
    token: 'd70d579b2a5f48f09a3e05be4362d9ac',
  };
  flagSmithConfig!: IInitConfig;
  brazeUrl = 'https://rest.iad-01.braze.com' as const;
  brazeRestApiKey = 'acd7699d-1be4-4bdf-b8c0-55be745812e4' as const;
  brazeWorkspaceApiKey!:
    | '956c645c-d552-491e-8edb-98987a3a71d4'
    | 'd8baab59-c614-415b-8171-ff4fedc914f5'
    | 'fb4eae6d-3996-4d2a-aaf9-d7ab82e8c220';
  brazeUuidHash = '896d6b39-367c-430c-99fb-2af9972ee2d1' as const;
  pcMilerWebServicesApiKey:
    | '1D6B42C5799EA143B45FC1320533ADFE'
    | '48667533B12E8942B038B8533A35F4A5' = '48667533B12E8942B038B8533A35F4A5';
  onboardingSite!: OnboardingSiteConfig;
  accountManagerSite!: AccountManagerSiteConfig;
  serviceApiBaseUrls!: ServiceApiBaseUrls;

  constructor(overrides: Environment) {
    Object.assign(this, overrides);
  }
}
